import pick from 'lodash/pick';
import groupBy from 'lodash/groupBy';
import { types } from './types';
import { isEmpty } from 'lodash';
// import { isNil } from 'lodash';
import {
  documentKeys,
  carrierKeys,
  bankKeys,
  termsKeys,
  AssetKeys,
  kadBranchesKeys,
  auditorKeys,
  objectionKeys
} from 'store/utils';
import { calculateBusinessPlanOverviewTables } from './utils';
import { jv_banks } from 'utils/jvBanks';

const INITIAL_STATE = {
  documents: {},
  carrier: {
    viewMode: false,
    existCon: true,
    contactPersonFlag: true,
    additionalServices: true,
    ownerStatus: 'ownerStatusOwner',
    residence: true,
    powerSupply: true,
    powerSupplyPrivate: true,
    powerSupplyPublic: true,
    ameaMember: false,
    currentSubTab: 0,
    abiDistrictBuildingOptions:[],
    buildPerfectureBuildingOptions:[],
    abiDistrictOptions:[],
    abiPerfectureOptions:[],
    selectedActivityAreasCodes: [],
    regionalUnitiesActivityArea: [],
    municipalitiesActivityArea: [],
    applicationReturned:false,
    carrierUsersStatic:[]
  },
  bank: {
    requiresIbanUpdate: false, 
  },
  items: {
    jvBanks: jv_banks,
  },
  formId: '',
  task: {},
  content: [],
  localeStrings: [],
  loadingLocales: false,
  appConfig: {
    initiated: false,
    hasError: false,
    hasInfo: false,
    loading: false,
    message: '',
    gsisAuthUrl: true,
    rememberMe: false,
  },
  auditor:{
    consent: false
  },
  objection:{
    consentByCommittee: false
  },
  applicationLoading: false,
  equipmentRequests:[],
  equipment:{
    submittingEquipment:false
  }
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SET_FORM_INITIATED:
      return { ...state, initiated: true };

    case types.SET_FORM_INFO:
      return { ...state, hasInfo: true, message: payload };

    case types.UPDATE_USER.SUCCESS:
      return { ...state, ...payload };

    case types.UPLOAD_FILE.SUCCESS:
      return {
        ...state,
      };

      case types.LOAD_SYSTEM_LOCALES.START:
        return {
          ...state,
          loadingLocales: true, // Set loading to true when fetching locales
        };
  
      case types.LOAD_SYSTEM_LOCALES.SUCCESS: {
        const locales = {}; // Declare locales only once
        if (Array.isArray(payload)) {
          payload.forEach(({ name, localString }) => {
            locales[name] = localString;
          });
        } else {
          console.warn("LOAD_SYSTEM_LOCALES.SUCCESS payload is not an array:", payload);
        }
  
        return {
          ...state,
          localeStrings: locales,  // Store fetched locales
          loadingLocales: false,   // Set loading to false when locales are fetched
        };
      }
  
      case types.LOAD_SYSTEM_LOCALES.ERROR:
        return {
          ...state,
          loadingLocales: false,  // Set loading to false if fetching fails
        };

    case types.LOGIN_START:
      return { ...state, loading: true, hasError: false, message: '' };

    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        hasError: false,
        message: '',
      };

    case types.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        hasError: true,
        message: payload,
      };

    case types.RESET_USER:
      console.log('Reducer - Resetting User');
      return {
        ...state,
        initiated: false,
        hasError: false,
        hasInfo: false,
        loading: false,
        message: '',
        gsisAuthUrl: null,
        rememberMe: false,
      };

    case types.UPDATE_FORM_FIELD_FORMS:
      return {
        ...state,
        [payload.group]: {
          ...state[payload.group],
          [payload.key]: payload.value,
        },
      };
    case types.UPDATE_ONE_FORM_FIELD_FORMS:
      return {
        ...state,
          [payload.key]: payload.value,
        };
    case types.GET_PROCESS_INSTANCES.SUCCESS:
      const content = groupBy(payload.content, 'field');
      return {
        ...state,
        documents: {
          ...pick(payload.variables, documentKeys(payload.variables)),
          ...content,
        },
        carrier: {
          viewMode: state.carrier.viewMode,
          existCon: state.carrier.existCon,
          contactPersonFlag: state.carrier.contactPersonFlag,
          ...pick(payload.variables, carrierKeys(payload.variables)),
        },
        bank: {
          ...state.bank,
          ...pick(payload.variables, bankKeys(payload.variables)),
        },
        terms: {
          ...state.terms,
          ...pick(payload.variables, termsKeys(payload.variables)),
        },
        kadBranches: {
          ...state.kadBranches,
          ...pick(payload.variables, kadBranchesKeys(payload.variables)),
        },
        auditor: {
          ...state.auditor,
          ...pick(payload.variables, auditorKeys(payload.variables)),
        },
        objection: {
          ...state.objection,
          ...pick(payload.variables, objectionKeys(payload.variables)),
        },
        businessPlanDetails: {
          ...state.businessPlanDetails,
          ...pick(payload.variables, AssetKeys(payload)),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
        },
        activeTaskName: payload?.activeTaskName || state.forms?.activeTaskName,
        businessKey: payload.businessKey || state.forms?.businessKey,
        task: {
          ...state.task,
          processInstanceId:
            payload?.processInstanceId || state.forms.task.processInstanceId,
          taskName: payload?.taskName || state.forms.task.taskName,
          taskKey: payload?.taskKey || state.forms.task.taskKey,
        },
      };
    case types.GET_FORM_DATA.SUCCESS :
      // const contentItems = groupBy(payload.contentItems, 'field');
      return {
        ...state,
        documents: {
          ...state.documents,
          ...pick(payload.variables, documentKeys(payload.variables)),
          // ...contentItems,
        },
        carrier: {
          ...state.carrier,

          viewMode: state.carrier.viewMode,
          ...pick(payload.variables, carrierKeys(payload.variables)),
          ...pick(payload.variables.carrierUsers, 'carrierUsers'),
        },
        bank: {
          ...state.bank,
          ...pick(payload.variables, bankKeys(payload.variables)),
        },
        terms: {
          ...state.terms,
          ...pick(payload.variables, termsKeys(payload.variables)),
        },
        kadBranches: {
          ...state.kadBranches,
          ...pick(payload.variables, kadBranchesKeys(payload.variables)),
        },
        businessPlanDetails: {
          ...state.businessPlanDetails,
          ...pick(payload.variables, AssetKeys(payload.variables)),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
          ...pick(
            payload.variables,
            Object.keys(calculateBusinessPlanOverviewTables())
          ),
        },
        formId: payload?.taskKey || state.forms.formId,
        task: {
          ...state.task,
          processInstanceId:
            payload?.processInstanceId || state.forms.task.processInstanceId,
          taskName: payload?.taskName || state.forms.task.taskName,
          taskKey: payload?.taskKey || state.forms.task.taskKey,
        },
        activeTaskName: payload?.taskName
      };
      case types.GET_MAINFORM_DETAILS.SUCCESS :
        return {
          ...state,
          documents: {
            ...state.documents,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), documentKeys(!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed)),
            contentItems: payload.contentItems ?? [],
          },
          carrier: {
            ...state.carrier,
            viewMode: state.carrier.viewMode,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), carrierKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed).carrierUsers, 'carrierUsers'),
          },
          bank: {
            ...state.bank,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), bankKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
          initialBeneficiaryIban: payload.variablesIndexed?.beneficiaryIban,
          },
          terms: {
            ...state.terms,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), termsKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
          },
          kadBranches: {
            ...state.kadBranches,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), kadBranchesKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
          },
          auditor: {
            ...state.auditor,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), auditorKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
          },
          objection: {
            ...state.objection,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), objectionKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
          },
          businessPlanDetails: {
            ...state.businessPlanDetails,
            ...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed), AssetKeys((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed))),
            ...pick(
              (!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed),
              Object.keys(calculateBusinessPlanOverviewTables())
            ),
            ...pick(
              (!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed),
              Object.keys(calculateBusinessPlanOverviewTables())
            ),
          },
          carrierUsersStatic: {...pick((!isEmpty(payload.localTaskVariables) ? payload.localTaskVariables : payload.variablesIndexed).carrierUsers, 'carrierUsers')},
          formId: payload?.taskKey || state.forms?.formId,
          task: {
            ...state.task,
            // processInstanceId:
            //   payload?.processInstanceId || state.forms?.task?.processInstanceId,
            // taskName: payload?.taskName || state.forms?.task?.taskName,
            // taskKey: payload?.taskKey || state.forms?.task?.taskKey,
          },
          activeTaskName: payload?.activeTaskName,
          businessKey: payload?.businessKey,
        };
      case types.UPDATE_IBAN.SUCCESS:
        return state;
        
      case types.UPDATE_IBAN.ERROR:
          return {
          ...state,
          error: payload  
        };
    case types.GET_TASK_DATA.SUCCESS:
      return {
        ...state,
        task: {
          ...state.task,
          ...payload,
        },
      };
      case types.GET_TAXIS_DATA_BY_TK.SUCCESS:
        return {
          ...state,
          carrier: {
            ...state.carrier,
            abiDistrictBuildingOptions: Array.from(
              new Set(payload.map(b=>b.area))
            ).map(area=>({
              value: area,
            })),
            buildPerfectureBuildingOptions: Array.from(
              new Set(payload.map(b=>b.nomos))
            ).map(nomos=>({
              value: nomos,
            }))
          },
        };
    case types.GET_TAXIS_DATA_BY_ABI_TK.SUCCESS:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          abiDistrictOptions:payload.map(b => ({
            value: b.area,
          })),
          abiPerfectureOptions:payload.map(b => ({
            value: b.nomos,
          })),
        },
      };
      case types.GET_KAD_BRANCHES.SUCCESS:
        return {
          ...state,
          kadBranches: {
            ...state.kadBranches,
            ...pick(payload, kadBranchesKeys(payload)),
          },
      };
      case types.GET_IBAN_VALIDATION.SUCCESS:
        return {
          ...state,
          bank: {
            ...state.bank,
            ibanValidation: payload,
          },
      };
      case types.GET_IBAN_VALIDATION.ERROR:
        return {
          ...state,
          bank: {
            ...state.bank,
            ibanValidation: payload,
          },
      };
      case types.GET_IBAN_VALIDATION_WITH_BANK.SUCCESS:
        return {
          ...state,
          bank: {
            ...state.bank,
            ibanValidation: payload,
          },
      };
      case types.GET_IBAN_VALIDATION_WITH_BANK.ERROR:
        return {
          ...state,
          bank: {
            ...state.bank,
            ibanValidation: payload,
          },
      };
      
    case types.GET_REQUESTS.SUCCESS:
      return {
        ...state,
        equipmentRequests: {
         ...payload
        },
    };
    case types.GET_OTP.SUCCESS:
      return {
        ...state,
        // task: {
        //   ...state.task,
        //   ...payload,
        // },
      };
    case types.UPDATE_BUSINESS_PLAN_EXPENSE:
      return {
        ...state,
        businessPlanDetails: {
          ...state.businessPlanDetails,
          ...calculateBusinessPlanOverviewTables(state),
        },
      };
    case types.START_NEW.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
        task: {
          ...state.task,
          processInstanceId: payload.processInstanceId,
        },
        carrier: {
          ...state.carrier,
          viewMode: false,
        },
      };
    case types.CLAIM_ACTIVE.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
      };
    case types.CLAIM_ACTIVE_VIEW_MODE.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
      };
    case types.GET_FORM_UPLOADS.SUCCESS:
      return {
        ...state,
        content: payload.data,
      };
    case types.GET_PROJECT_PLAN_INFO.SUCCESS:
      return {
        ...state,
        projectPlanInfo: payload,
      };

    case types.CLEAR_FORM.SUCCESS:
      return INITIAL_STATE;

    case types.VALIDATE_OTP.SUCCESS:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          [payload.field + 'Validated']: true,
          otpError: payload.otpError,
        },
      };
    case types.VALIDATE_OTP.ERROR:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          [payload.field + 'Validated']: false,
          otpError: payload.otpError,
        },
      };
    case types.APPROVE_AUDIT.START:
      return {
        ...state,
        submitting: true,
      };
    case types.APPROVE_AUDIT.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_AUDIT.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_AUDIT.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.APPROVE_OBJECTION.START:
      return {
        ...state,
        submitting: true,
      };
    case types.APPROVE_OBJECTION.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_OBJECTION.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_OBJECTION.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_TASK.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_TASK.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.SUBMIT_TASK.START:
      return {
        ...state,
        submitting: true,
      };
    case types.SUBMIT_TASK.SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case types.SUBMIT_TASK.ERROR:
      return {
        ...state,
        submitting: false,
        error: payload,
      };
    case types.SUBMIT_CARRIER_USERS.ERROR:
      return {
        ...state,
        submitting: false,
        error: payload,
      };
    case types.GET_EQUIPMENT_REQUESTS.ERROR:
      return {
        ...state,
        equipment:{
          submittingEquipment:true
        }
      };
    case types.UPDATE_REQUEST_STATUS.ERROR:
      return {
        ...state,
        equipment:{
          submittingEquipment:true,
          error: payload,
        }
      };
    case types.UPDATE_FORM_VALIDITY:
      return {
        ...state,
        formValidity: {
          ...state.formValidity,
          [payload.group]: payload.value,
        },
      };
    case types.SUBMIT_CONSENT.SUCCESS:
      return {
        ...state,
        consent: payload.consent,
      };
    case types.TRIGGER_LOADING:
      return {
        ...state,
        applicationLoading: payload,
      };
    case types.LOAD_SYSTEM_LOCALES.SUCCESS:
      //console.log("LOAD_SYSTEM_LOCALES.SUCCESS payload:", payload);
      const locales = {};
      if (Array.isArray(payload)) {
        payload.forEach(({ name, localString }) => {
          locales[name] = localString;
        });
      } else {
        console.warn(
          'LOAD_SYSTEM_LOCALES.SUCCESS payload is not an array:',
          payload
        );
      }

      return {
        ...state,
        localeStrings: locales,
      };
    default:
      return state;
  }
};

export default reducer;
